import React from 'react';
import ModuleDetailPage from './ModuleDetailPage';

const QROrderPage = () => <ModuleDetailPage moduleId="qr-order" />;

export default QROrderPage;
